/**
 * lit-shell.js version
 * This is automatically kept in sync with package.json
 */
export const VERSION = '1.2.0';
